module.exports = __webpack_public_path__ + "img/Back Barbell.7930ffb6.png";